import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import { NavLink, useHistory } from "react-router-dom";
import { RouteService } from "../../services/route.service";
import PersonIcon from "@material-ui/icons/Person";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import Profile from "../Profile/Profile";
import {Button, Grid, IconButton} from "@material-ui/core";
import { getCustomer } from "../../store/home/selector";
import ErrorModal from "../Modals/ErrorModal";
import Text from "../Text/Text";
import { getUserContextData } from "../../store/login/selector";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import moment from "moment";
import { getSystemAlert } from "../../store/systemAlert/action";

const useStyles = makeStyles({
  home: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "60px",
  },
  active: {
    background: "#dde9ff",
    boxShadow: "1px 0 1px 1px #ccc",
    borderBottom: "3px solid #3f51b5",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  activeLinks: {
    background: "#dde9ff",
    boxShadow: "1px 0 1px 1px #ccc",
    borderBottom: "4px solid #3f51b5",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "16vw",
  },
  navClass: {
    color: "#3f51b5",
    textDecoration: "none!mportant",
  },
  userContainer: {
    borderLeft: "1px solid gray",
    // height: "7vh",
    width: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  text: {
    fontWeight: 700,
  },
  Decoration: {
    textDecoration: "none",
  },
  dbFlex: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#ff0",
    fontWeight: "bold",
    position: "relative",
    // marginTop: "10px",
    marginBottom: "5px",
  },
  securityContauner: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    paddingRight: "15px",
    gap: "10px",
  },
  iconColor: {
    color: "white",
  },
  texts: {
    color: "white",
    fontSize: "12px",
    // fontWeight:800,
  },
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  navLink: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "transparent linear-gradient(180deg, #1F4A98 0%, #10254C 100%) 0% 0% no-repeat padding-box",
    height: "28px",
    borderRadius: "8px",
    padding: "2px 15px",
    marginLeft: "5px",
  },
  flexCenter: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    background:
      "transparent linear-gradient(180deg, #1F4A98 0%, #10254C 100%) 0% 0% no-repeat padding-box",
    boxShadow: "2px 5px 6px #00000029",
    height: "28px",
    padding: "2px 8px",
    borderRadius: "10px",
    textDecoration: "none",
    marginRight: "25px"
  },
  fullHeight: {
    height: "100%",
  },
});

const NavigationBar = (props) => {
  let homeStore = useSelector((state) => state["homeState"]);
  const customerName = useSelector(getCustomer);
  const userDetails = useSelector(getUserContextData);
  const history = useHistory();
  const [profileOpen, setProfileOpen] = React.useState(null);
  const dispatch = useDispatch();
  const userDetailss = useSelector(
    (state) => state?.loginState?.citationEnabled?.citationsEnabled
  );
  const StylingItem = props.StylingItem;
  const handleProfile = (event) => {
    setProfileOpen(event.currentTarget);
  };
  const handleClose = () => {
    setProfileOpen(null);
  };
  const classes = useStyles();
  var isCitationEnabled = false;
  try {
    // isCitationEnabled = userDetails?.client.citationsEnabled;
    isCitationEnabled = userDetailss;
  } catch (e) { }
  const mainContainer = {
    width: "100%",
    background: "#f5cd1c",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "1px 0 1px 1px #ccc",
    height: "50px",
  };
  const [alertMessage, setAlertMessage] = React.useState();
  const [toggle, setToggle] = React.useState(true);
  
  const handleToggle = (e) => {
    if (toggle == true) {
      setToggle(false);
    } else {
      setToggle(true);
    }
  };
  
  const systemAlertMessage = useSelector(
    (state) => state?.SystemAlertReducer?.systemAlert
  );
  React.useEffect(() => {
    setAlertMessage(systemAlertMessage);
  }, [systemAlertMessage]);
  
  const currentDatetime = Date();
  
  var isafter = moment(alertMessage?.endDate).isAfter(currentDatetime);
  var isbefore = moment(alertMessage?.startDate).isAfter(currentDatetime);
  
  const [open, setOpen] = React.useState(false);
  
  
  const clientName = useSelector(
    (state) => state.loginState?.userContext?.user?.userName
  );
  

  React.useEffect(() => {
    setOpen(alertMessage?.enabled);
  }, [alertMessage]);

  React.useEffect(() => {
    dispatch(getSystemAlert("djd"));
  }, []);

  // useEffect(() => {
  //   dispatch(getUserContext());
  // }, []);

  //Start navigation Alert
  const getAlert = () => {
    if (isafter === true && isbefore === false && open) {
      return (
        <>
          <div className={classes.dbFlex}>
            <span
              id="editor-text-id"
              className="ql-editor"
              style={{ padding: "7px" }}
              dangerouslySetInnerHTML={{ __html: alertMessage?.body }}
            />
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
              style={{ position: "absolute", right: "5px" }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        </>
      );
    } else {
      return null;
    }
  };
  //End code

  return (
    <>
      <div
        className="mobile_nav"

        style={{
          ...mainContainer,
          ["background"]: StylingItem && StylingItem.navigationBarColor,
          textDecoration: "none",
          marginBottom: "3px",
          boxShadow: "0 3px #d5d5d5",
        }}
      >
        <NavLink
          style={{ textDecoration: "none" }}
          to={RouteService.dashboard(homeStore.customerName)}
          className={classes.home} 
          activeClassName={classes.active}
        >
          {clientName === "clientadmin" ?
            <div className={classes.center}>
              <NavLink
                to={RouteService.home(homeStore.customerName)}
                className={classes.navLink}
                activeClassName={classes.navLink}
              >
              <IconButton
              title="Home">
                <HomeIcon className={classes.iconColor} />
                </IconButton>
                
              </NavLink>
            </div> :
            <IconButton
              title="Home">
            <HomeIcon color="primary" aria-label="Home"/>
            </IconButton>}
        </NavLink>
        <a
          tabindex="0"
          className="humb"
          onClick={(e) => {
            handleToggle(e);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 64 64"
          >
            <line
              x2="64"
              y1="15.95"
              y2="15.95"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="5"
              stroke-width="6"
            />
            <line
              x2="64"
              y1="32.15"
              y2="32.15"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="5"
              stroke-width="6"
            />
            <line
              x2="64"
              y1="48.05"
              y2="48.05"
              fill="none"
              stroke="#fff"
              stroke-miterlimit="5"
              stroke-width="6"
            />
          </svg>
        </a>
        <NavLink
          style={{ textDecoration: "none" }}
          to={RouteService.buyPermits(homeStore.customerName)}
          className={toggle == true ? classes.navClass : "show_menu"}
          activeClassName={classes.activeLinks}
        >
          <Text className={classes.text} >Order Permits</Text>
        </NavLink>
        <NavLink
          style={{ textDecoration: "none" }}
          to={RouteService.viewOrders(homeStore.customerName)}
          className={toggle == true ? classes.navClass : "show_menu"}
          activeClassName={classes.activeLinks}
        >
          <Text className={classes.text}>View Orders</Text>
        </NavLink>
        {isCitationEnabled && (
          <NavLink
            style={{ textDecoration: "none" }}
            to={RouteService.citation(homeStore.customerName)}
            className={toggle == true ? classes.navClass : "show_menu"}
            activeClassName={classes.activeLinks}
          >
            <Text className={classes.text}>Manage Citations</Text>
          </NavLink>
        )}
        <div
          // tabindex="1"
          tabIndex="0"
          onKeyDown={(event) => {
            if (event.key === "Tab") {
              // event.preventDefault();
              // handleSelectPermit(item?.id);
              RouteService.profilePage(customerName)
            }
          }}
          className={`${classes.userContainer} ${classes.fullHeight} ${history.location.pathname === RouteService.profilePage(customerName)
            ? classes.active
            : ""
          }`}
        >
          {clientName === "clientadmin" ?
            <div className={classes.securityContauner} tabIndex='0'>
              <NavLink
                to={RouteService.login(homeStore.customerName)}
                className={classes.flexCenter}
              >
                <LockIcon className={classes.iconColor}  />
                <div className={classes.texts} style={{ paddingRight: "10px" }}>
                  Login
                </div>
              </NavLink>
            </div>
            :
            <div className={`${classes.center} ${classes.fullHeight}`}>
              <Grid container justify="center" alignItems="center" className={classes.fullHeight}>
                <Profile open={profileOpen} onClose={handleClose}/>
                <Button
                  title="Account Page"
                  onClick={handleProfile}
                  size="large"
                  className={classes.fullHeight}
                >
                  <PersonIcon color="primary"/>
                  <ArrowDropDownIcon color="primary"/>
                </Button>
              </Grid>
            </div>
          }
        </div>
      </div>
      <ErrorModal />
      {getAlert()}
    </>
  );
};
export default NavigationBar;